import { reatomAsync } from '@reatom/async';
import { atom } from '@reatom/core';
import { withLocalStorage } from '@reatom/persist-web-storage';
import { BACKEND_API, Product, SearchProductEntity } from '@trwl/backend.api';
import { loadCartAction } from '@trwl/store/actions';

type Like = Product | SearchProductEntity;

const likesAtom = atom<Like[]>([], 'likesAtom').pipe(
  withLocalStorage('likesAtom'),
);

const loadLikesAction = reatomAsync(async (ctx) => {
  return BACKEND_API.StatsApi.getFavourites().then(({ data }) => {
    likesAtom(ctx, data);
  });
});

const isLikesLoadingAtom = atom(
  (ctx) => ctx.spy(loadCartAction.pendingAtom) > 0,
  'isLikesLoadingAtom',
);

const likeEffect = reatomAsync((ctx, productId: number) => {
  return BACKEND_API.StatsApi.like(productId);
}, 'likeEffect');

const likeAction = reatomAsync((ctx, product: Like) => {
  likesAtom(ctx, (state) => Array.from(new Set([...state, product])));
  return likeEffect(ctx, product.id);
}, 'likeAction');

const dislikeAction = reatomAsync((ctx, product: Like) => {
  likesAtom(ctx, (state) => state.filter((like) => like.id !== product.id));
  return BACKEND_API.StatsApi.dislike(product.id);
}, 'dislikeAction');

const isItemLiked = (store: Like[], product: Like) =>
  store.find((like) => like.id === product.id);

export {
  likesAtom,
  likeEffect,
  likeAction,
  dislikeAction,
  loadLikesAction,
  isLikesLoadingAtom,
  isItemLiked,
};
